
<div class="modal-icon">
    <div class="insurance--group--icon padding-0">
        <ul class="drug--icons">
            <span class="padding_right_0_8rem" *ngIf="drugId">
                <i class="fa-kit fa-drug-sales header-icon font_size_2_5rem" title="Drug Sales Summary" aria-hidden="true" (click)="openModal('SalesSummary')"></i>
            </span>
            <span class="padding_right_0_8rem">
                <i class="far fa-copy header-icon" title="Copy Info From Another Drug" aria-hidden="true" (click)="openModal('copyDrug')"></i>
            </span>
            <span class="icons--padding">
                <i class="far fa-sync-alt header-icon" title="Refresh Data from MMS" (click)="openModal('MMS')"></i>
            </span>
            <span class="icons--padding" *ngIf="drugId">
                <i class="fa-kit fa-all-ndc-list header-icon font_size_2_5rem" title="Show All NDC Occurrences" (click)="openModal('NdcOcc')"></i>
            </span>
            <span class="icons--padding headerImage" *ngIf="drugId">
                <img src="assets/dist/Icons/icon_pills_white.svg"  (click)="openEquivalentPopUp()" title="Equivalent Drug" class="headerimg header-icon"/>
            </span>
        </ul>
    </div>
</div>

<app-drug-sales-summary *ngIf="actvModal === 'SalesSummary'" [drugInfo]="drugInfo" [drugId]="drugId" (IsPopUpClosed)="openModal($event)"></app-drug-sales-summary>
<app-drug-ndcocc *ngIf="actvModal === 'NdcOcc'" [drugCode]="drugInfo?.Drug?.DrugCode" (IsPopUpClosed)="openModal($event)"></app-drug-ndcocc>
<app-drug-refresh-mms *ngIf="actvModal === 'MMS'" [drugInfo]="drugInfo" [drugId]="drugId" [drugFG]="drugFg" [systemData]="systemData" [dropDownValue]="dropDownValue" [MMSDataDPV]="MMSDataDPV" (IsPopUpClosed)="openModal($event)" (DataforDrugManfact) = "dataforDrugManfact($event)"></app-drug-refresh-mms>
<app-drug-copy *ngIf="actvModal === 'copyDrug'" [originalData]="drugInfo" [drugFG]="drugFg" (IsPopUpClosed)="openModal($event)" (EmitOpenCompndDrug)="openCompPopup($event)" [miscFG]="miscFG" [miscInfo]="miscInfo"></app-drug-copy>
